import { getConditionsFilterConfig } from '../filters/condition';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getSizeFilterConfig } from '../filters/size';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';

const lane201Sizes = [
  'One Size',
  'Small',
  'Medium',
  'Large',
  'Extra Large',
  '2XL',
  '3XL',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '5.5',
  '6',
  '6.5',
  '7',
  '7.5',
  '8',
  '8.5',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
];

const allSizeVariantOptionNames = ['size', 'shoe size'];

export const lane201ShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getBrandDirectFilterConfig(),
    getConditionsFilterConfig(),
    getSizeFilterConfig({ sizes: lane201Sizes }),
  ],
  allSizeVariantOptionNames,
};
